import ListPage, { useList } from '@/components/BaseList';
import { usePermission } from '@/common/hooks/index';
import { httpPageOdsNhsaTcmDrinks } from '@/services/datamanagement';
import React from 'react';
import SearchForm from './components/SearchForm';

/**
 * 医保药品数据库（中药饮片）
 * @returns
 */
const ChineseMedicine: React.FC = () => {
  const { permission } = usePermission();

  const list = useList();
  const fetchAPi = (params: any) => {
    const req: any = {
      // ...params,
      limit: params.pageSize,
      pageNo: params.current,
      cond: {
        piecesCode: params.piecesCode,
        piecesName: params.piecesName,
      },
      orders: [
        // {
        //   direction: params.direction === 'ascend' ? 'ASC' : 'DESC',
        //   property: params.property || 'createTime',
        // },
      ],
    };

    return httpPageOdsNhsaTcmDrinks(req).then((res) => {
      return {
        listData: res.data,
        pagination: {
          current: res.pageIndex,
          pageSize: res.pageSize,
          total: res.totalCount,
        },
      };
    });
  };

  const changetable = (pagination: any, filters: any, sorter: any) => {
    const property: string = sorter.columnKey;
    list.current.fetchListData({ direction: sorter.order, property });
  };

  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 100,
      ellipsis: true,
      children: [
        {
          title: 'id',
          dataIndex: 'id',
          width: 100,
          key: 'id',
        },
      ],
    },
    {
      title: '中药饮片名称',
      dataIndex: 'piecesName',
      key: 'piecesName',
      children: [
        {
          title: 'piecesName',
          dataIndex: 'piecesName',
          key: 'piecesName',
        },
      ],
    },
    {
      title: '中药饮片代码',
      dataIndex: 'piecesCode',
      key: 'piecesCode',
      children: [
        {
          title: 'piecesCode',
          dataIndex: 'piecesCode',
          key: 'piecesCode',
        },
      ],
    },
  ];

  return (
    <div>
      <ListPage
        list={list}
        fetchApi={fetchAPi}
        columns={columns}
        SearchForm={permission.sysSearchBtn && SearchForm}
        BodyProps={{
          onChange: (pagination: any, filters: any, sorter: any) => {
            changetable(pagination, filters, sorter);
          },
        }}
      />
    </div>
  );
};

export default ChineseMedicine;
